let interval = setInterval(() => {
    let eyeprev = document.querySelector('.eye-preview');

    if (eyeprev) {
        refreshFsLightbox();
        console.log('Lightbox refreshed');
        clearInterval(interval);
    }
}, 400);